import Link from "next/link";

import { Anchor, Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  withTrackEvent,
  objectTypes,
} from "@newsela/snitch";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { anchorCss } from "../ViewPageError.style";

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const SignUpCta = () => {
  const eventProperties = {
    objectType: objectTypes.user,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.navigate,
    streamProperties: {
      description: "Navigate to Sign Up page from View page",
    },
  };

  return (
    <Link href={`${MONOLITH_ORIGIN}/join`} passHref legacyBehavior>
      <AnchorWithTrackEvent
        __cssFor={{ root: anchorCss }}
        styleAnchorAsButton={{
          flavor: Button.flavors.secondary,
        }}
        dataProps={{ "data-qa-selector": "sign_up_cta" }}
        {...eventProperties}
      >
        Sign up
      </AnchorWithTrackEvent>
    </Link>
  );
};

export default SignUpCta;
